"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("path", {
    d: "M396.3 125v250c0 11.5-9.4 20.8-20.8 20.8h-250c-11.5 0-20.8-9.4-20.8-20.8V270.8c0-11.5-9.4-20.8-20.8-20.8S63 259.4 63 270.8v125c0 23.1 18.8 41.7 41.7 41.7h291.7c22.9 0 41.7-18.8 41.7-41.7V104.2c0-22.9-18.8-41.7-41.7-41.7h-125c-11.5 0-20.8 9.4-20.8 20.8s9.4 20.8 20.8 20.8h104.2c11.4.1 20.7 9.4 20.7 20.9z"
  }), (0, _core.jsx)("path", {
    d: "M309.5 184c-11.5 0-20.8 9.4-20.8 20.8v54L98.5 68.6c-8.1-8.1-21.2-8.1-29.4 0S61 89.8 69.1 98l190.2 190.2h-54c-11.5 0-20.8 9.4-20.8 20.8 0 11.5 9.4 20.8 20.8 20.8h104.2c11.5 0 20.8-9.4 20.8-20.8V204.8c0-11.4-9.3-20.8-20.8-20.8z"
  }));
};

exports.default = _default;